// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeroSection_heading__Efwh\\+ {
  font-family: Poppins;
  font-weight: 500;
  color: #333333;
  padding-right: 9px;
  margin-top: 50px;
  margin-bottom: 1.6rem;
}
.HeroSection_background__VD-Ij {
  position: absolute;
  z-index: -1;
  /* width:400px */
  /* padding-left: 30px; */
  height: 525px;
  width: 687px;
}
/* .imageContainer {
    position: relative; 
  } */
.HeroSection_heroImage__jcQ42 {
  /* position: absolute; */
  /* z-index: 4; */
  margin-top: 50px;
  /* margin-right: 200px; */
  height: 430px;
  width: 570px;
}
.HeroSection_text__JsAMK {
  color: #797c7b;
  font-family: Poppins;
  font-size: 17px;
  padding-right: 4rem;
}
.HeroSection_stats__1UBdc {
  display: flex;
  align-items: center;
  /* margin: 20px 0; */
  margin-top: 10px;
  margin-bottom: 20px;
}
.HeroSection_number__4jRDG {
  font-family: Poppins;
  font-size: 24px;
}
.HeroSection_profileDiv__E-Y8B {
  margin-top: 12px;
}
.HeroSection_textUser__77KK8 {
  font-family: Poppins;
  color: #797c7b;
  font-size: 14px;
}

.HeroSection_cta__vRLij {
  background-color: #FF6500;;
  color: white;
  padding: 10px 20px;
  font-family: Poppins;
  margin-bottom: 1rem;
  font-size: 14px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}
.HeroSection_customer__LUG-O {
  margin-right: 8px;
}
.HeroSection_hero__3Cdc9{
  overflow: hidden;
}
/* @media (min-width: ) and (max-width: 912px) */
@media (min-width: 300px) and (max-width: 400px) {
  .HeroSection_hero__3Cdc9{
    width: 413px;
  }

  .HeroSection_background__VD-Ij {
    width: 378px;
    height: 412px;
  }
  .HeroSection_heroImage__jcQ42{
    height: 381px;
    width: 270px;
  }
  .HeroSection_heading__Efwh\\+ {
    padding-right: 4px;
  }
  .HeroSection_text__JsAMK{
    padding-right: 1.3rem;
  }
}
@media (min-width : 400px) and (max-width: 576px) {
  .HeroSection_hero__3Cdc9{
    width: 425px;
  }
  .HeroSection_customer__LUG-O {
    margin-right: 8px;
    margin-left: 12px;
  }
  .HeroSection_heading__Efwh\\+ {
    padding-right: 0;
    font-size: 22px;
    margin-top: 20px;
    margin-left: 18px;
  }
  .HeroSection_text__JsAMK {
    padding-right: 0rem;
    margin-left: 18px;
  }

  .HeroSection_cta__vRLij {
    margin-left: 14px;
  }
  .HeroSection_background__VD-Ij {
    width: 431px;
    height: 471px;
  }
  .HeroSection_heroImage__jcQ42{
    height: 430px;
    width: 348px;
  }

}

@media (min-width: 576px) and (max-width: 1180px) {
  .HeroSection_background__VD-Ij {
    width: 733px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/HeroSection.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,YAAY;AACd;AACA;;KAEK;AACL;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA,gDAAgD;AAChD;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,aAAa;IACb,YAAY;EACd;;AAEF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".heading {\n  font-family: Poppins;\n  font-weight: 500;\n  color: #333333;\n  padding-right: 9px;\n  margin-top: 50px;\n  margin-bottom: 1.6rem;\n}\n.background {\n  position: absolute;\n  z-index: -1;\n  /* width:400px */\n  /* padding-left: 30px; */\n  height: 525px;\n  width: 687px;\n}\n/* .imageContainer {\n    position: relative; \n  } */\n.heroImage {\n  /* position: absolute; */\n  /* z-index: 4; */\n  margin-top: 50px;\n  /* margin-right: 200px; */\n  height: 430px;\n  width: 570px;\n}\n.text {\n  color: #797c7b;\n  font-family: Poppins;\n  font-size: 17px;\n  padding-right: 4rem;\n}\n.stats {\n  display: flex;\n  align-items: center;\n  /* margin: 20px 0; */\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n.number {\n  font-family: Poppins;\n  font-size: 24px;\n}\n.profileDiv {\n  margin-top: 12px;\n}\n.textUser {\n  font-family: Poppins;\n  color: #797c7b;\n  font-size: 14px;\n}\n\n.cta {\n  background-color: #FF6500;;\n  color: white;\n  padding: 10px 20px;\n  font-family: Poppins;\n  margin-bottom: 1rem;\n  font-size: 14px;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n}\n.customer {\n  margin-right: 8px;\n}\n.hero{\n  overflow: hidden;\n}\n/* @media (min-width: ) and (max-width: 912px) */\n@media (min-width: 300px) and (max-width: 400px) {\n  .hero{\n    width: 413px;\n  }\n\n  .background {\n    width: 378px;\n    height: 412px;\n  }\n  .heroImage{\n    height: 381px;\n    width: 270px;\n  }\n  .heading {\n    padding-right: 4px;\n  }\n  .text{\n    padding-right: 1.3rem;\n  }\n}\n@media (min-width : 400px) and (max-width: 576px) {\n  .hero{\n    width: 425px;\n  }\n  .customer {\n    margin-right: 8px;\n    margin-left: 12px;\n  }\n  .heading {\n    padding-right: 0;\n    font-size: 22px;\n    margin-top: 20px;\n    margin-left: 18px;\n  }\n  .text {\n    padding-right: 0rem;\n    margin-left: 18px;\n  }\n\n  .cta {\n    margin-left: 14px;\n  }\n  .background {\n    width: 431px;\n    height: 471px;\n  }\n  .heroImage{\n    height: 430px;\n    width: 348px;\n  }\n\n}\n\n@media (min-width: 576px) and (max-width: 1180px) {\n  .background {\n    width: 733px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `HeroSection_heading__Efwh+`,
	"background": `HeroSection_background__VD-Ij`,
	"heroImage": `HeroSection_heroImage__jcQ42`,
	"text": `HeroSection_text__JsAMK`,
	"stats": `HeroSection_stats__1UBdc`,
	"number": `HeroSection_number__4jRDG`,
	"profileDiv": `HeroSection_profileDiv__E-Y8B`,
	"textUser": `HeroSection_textUser__77KK8`,
	"cta": `HeroSection_cta__vRLij`,
	"customer": `HeroSection_customer__LUG-O`,
	"hero": `HeroSection_hero__3Cdc9`
};
export default ___CSS_LOADER_EXPORT___;
